import React, { useRef, useState } from 'react';
import constants from '../../utils/constants';
import MUITable from '../../components/Table-header/table';
import { flag_table_header } from '../../components/Table-header/table-header';
import { message, Modal, Input, Button, Select } from 'antd';
import axios from 'axios';

export default function FlagReview() {
    const renderListRef = useRef();
    const [modal, setModal] = useState(false);
    const [selectedFlag, setSelectedFlag] = useState(null);
    const [consultantName, setConsultantName] = useState('');
    const [dateFrom, setDateFrom] = useState('');
    const [dateTo, setDateTo] = useState('');
    const [flagType, setFlagType] = useState('');
    const [flagStatus, setFlagStatus] = useState('');
    const [appliedFilters, setAppliedFilters] = useState({ consultantName: '', dateFrom: '', dateTo: '', flagType: '', flagStatus: '' });

    const flagHndler = async () => {
        try {
            if (selectedFlag?.flag_type === 'negative_feedback') {
                const { data } = await axios.put(`${constants.SERVER_API}/admin/flag/update`, {
                    flagId: selectedFlag._id,
                    status: 'resolved'
                });
                if (data.success) {
                    message.success('Flag updated successfully');
                    setModal(false);
                    renderListRef.current.refetchList();
                }
            } else if (selectedFlag?.flag_type === 'refund_request') {
                const { data } = await axios.put(`${constants.SERVER_API}/admin/flag/refund_request`, {
                    flagId: selectedFlag._id,
                    status: 'resolved'
                });
                if (data.success) {
                    message.success('Flag updated successfully');
                    setModal(false);
                    renderListRef.current.refetchList();
                }
            }
        } catch (error) {
            console.log(error);
        }
    };

    return (
        <main style={{
            width: '100%',
            height: '100vh',
            backgroundColor: '#fff',
            padding: '30px 0 0 230px',
            boxSizing: 'border-box'
        }}>
            <div style={{
                width: '95%',
                margin: '0 auto',
                backgroundColor: '#f9f9f9',
                borderRadius: '10px',
                padding: '20px',
                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)'
            }}>
                <div style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: '12px',
                    alignItems: 'flex-end',
                    marginBottom: '16px',
                    padding: '12px',
                    backgroundColor: '#fff',
                    borderRadius: '8px',
                    border: '1px solid #eee'
                }}>
                    <div style={{ minWidth: '180px' }}>
                        <label style={{ display: 'block', marginBottom: '4px', fontSize: '12px', fontWeight: 600, color: '#555' }}>Consultant Name</label>
                        <Input
                            placeholder="Search by consultant name"
                            value={consultantName}
                            onChange={(e) => setConsultantName(e.target.value)}
                            allowClear
                            style={{ width: '100%' }}
                        />
                    </div>
                    <div>
                        <label style={{ display: 'block', marginBottom: '4px', fontSize: '12px', fontWeight: 600, color: '#555' }}>Date From</label>
                        <input
                            type="date"
                            value={dateFrom}
                            onChange={(e) => setDateFrom(e.target.value)}
                            style={{
                                padding: '6px 10px',
                                border: '1px solid #d9d9d9',
                                borderRadius: '6px',
                                fontSize: '14px',
                                width: '100%',
                                minWidth: '140px'
                            }}
                        />
                    </div>
                    <div>
                        <label style={{ display: 'block', marginBottom: '4px', fontSize: '12px', fontWeight: 600, color: '#555' }}>Date To</label>
                        <input
                            type="date"
                            value={dateTo}
                            onChange={(e) => setDateTo(e.target.value)}
                            style={{
                                padding: '6px 10px',
                                border: '1px solid #d9d9d9',
                                borderRadius: '6px',
                                fontSize: '14px',
                                width: '100%',
                                minWidth: '140px'
                            }}
                        />
                    </div>
                    <div style={{ minWidth: '160px' }}>
                        <label style={{ display: 'block', marginBottom: '4px', fontSize: '12px', fontWeight: 600, color: '#555' }}>Flag Type</label>
                        <Select
                            placeholder="All"
                            value={flagType || undefined}
                            onChange={setFlagType}
                            allowClear
                            style={{ width: '100%' }}
                            options={[
                                { value: '', label: 'All' },
                                { value: 'missed_call', label: 'Missed Call' },
                                { value: 'negative_feedback', label: 'Negative Feedback' },
                                { value: 'offline_session', label: 'Offline Session' },
                                { value: 'refund_request', label: 'Refund Request' },
                                { value: 'cancelled_call', label: 'Cancelled Call' }
                            ]}
                        />
                    </div>
                    <div style={{ minWidth: '140px' }}>
                        <label style={{ display: 'block', marginBottom: '4px', fontSize: '12px', fontWeight: 600, color: '#555' }}>Status</label>
                        <Select
                            placeholder="All"
                            value={flagStatus || undefined}
                            onChange={setFlagStatus}
                            allowClear
                            style={{ width: '100%' }}
                            options={[
                                { value: '', label: 'All' },
                                { value: 'pending', label: 'Pending' },
                                { value: 'resolved', label: 'Resolved' }
                            ]}
                        />
                    </div>
                    <Button type="primary" onClick={() => {
                        setAppliedFilters({ consultantName: consultantName.trim(), dateFrom, dateTo, flagType: flagType || '', flagStatus: flagStatus || '' });
                        setTimeout(() => renderListRef.current?.refetchList(), 0);
                    }}>
                        Apply
                    </Button>
                    <Button onClick={() => {
                        setConsultantName('');
                        setDateFrom('');
                        setDateTo('');
                        setFlagType('');
                        setFlagStatus('');
                        setAppliedFilters({ consultantName: '', dateFrom: '', dateTo: '', flagType: '', flagStatus: '' });
                        setTimeout(() => renderListRef.current?.refetchList(), 0);
                    }}>
                        Reset
                    </Button>
                </div>
                <MUITable
                    key={`flag-${appliedFilters.consultantName}-${appliedFilters.dateFrom}-${appliedFilters.dateTo}-${appliedFilters.flagType}-${appliedFilters.flagStatus}`}
                    defaultProps={{
                        pageSize: 10,
                    }}
                    fetchBaseURI={`${constants.SERVER_API}/admin/flag?consultantName=${encodeURIComponent(appliedFilters.consultantName)}&dateFrom=${encodeURIComponent(appliedFilters.dateFrom)}&dateTo=${encodeURIComponent(appliedFilters.dateTo)}&flagType=${encodeURIComponent(appliedFilters.flagType)}&flagStatus=${encodeURIComponent(appliedFilters.flagStatus)}&`}
                    ref={renderListRef}
                    columns={flag_table_header({
                        viewCB: (row) => {
                            setSelectedFlag(row);
                            setModal(true);
                        }
                    })}
                />
            </div>
    
            <Modal
                title={`Flag Request For : ${selectedFlag?.consultant_details?.name}`}
                open={modal}
                onOk={flagHndler}
                onCancel={() => {
                    setModal(false);
                    setSelectedFlag(null);
                }}
                okText="Approve"
                cancelText="Disapprove"
                width={700}
            >
                {selectedFlag?.flag_type === "negative_feedback" && <FlagCMP selectedFlag={selectedFlag} />}
                {selectedFlag?.flag_type === "refund_request" && <RefundCMP selectedFlag={selectedFlag} />}
            </Modal>
        </main>
    );
    
}


const FlagCMP = ({ selectedFlag }) => {
    return (
        <div style={{ height: '400px', overflowY: 'auto', padding: '16px' }}>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
                <div style={{ backgroundColor: '#f9f9f9', padding: '16px', borderRadius: '8px' }}>
                    <p style={{ color: '#666', fontWeight: '600', marginBottom: '8px' }}>Consultant:</p>
                    <p style={{ fontSize: '16px' }}>{selectedFlag?.consultant_details.name}</p>
                </div>
                {/* <div style={{ backgroundColor: '#f9f9f9', padding: '16px', borderRadius: '8px' }}>
                    <p style={{ color: '#666', fontWeight: '600', marginBottom: '8px' }}>User:</p>
                    <p style={{ fontSize: '16px' }}>{selectedFlag?.user_details?.name}</p>
                </div> */}
                <div style={{ backgroundColor: '#f9f9f9', padding: '16px', borderRadius: '8px' }}>
                    <p style={{ color: '#666', fontWeight: '600', marginBottom: '8px' }}>Feedback:</p>
                    <p style={{ fontSize: '16px' }}>{selectedFlag?.feedback_details.review}</p>
                </div>
                <div style={{ backgroundColor: '#f9f9f9', padding: '16px', borderRadius: '8px' }}>
                    <p style={{ color: '#666', fontWeight: '600', marginBottom: '8px' }}>Reason:</p>
                    <p style={{ fontSize: '16px' }}>{selectedFlag?.flag_reason}</p>
                </div>
            </div>
        </div>
    );
};


const RefundCMP = ({ selectedFlag }) => {
    return (
        <div style={{ height: '400px', overflowY: 'auto', padding: '16px' }}>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
                <div style={{ backgroundColor: '#f9f9f9', padding: '16px', borderRadius: '8px' }}>
                    <p style={{ color: '#666', fontWeight: '600', marginBottom: '8px' }}>Consultant:</p>
                    <p style={{ fontSize: '16px' }}>{selectedFlag?.consultant_details.name}</p>
                </div>
                <div style={{ backgroundColor: '#f9f9f9', padding: '16px', borderRadius: '8px' }}>
                    <p style={{ color: '#666', fontWeight: '600', marginBottom: '8px' }}>User Amount Deducted:</p>
                    <p style={{ fontSize: '16px' }}>{selectedFlag?.temporary_data.userAmount}</p>
                </div>
                <div style={{ backgroundColor: '#f9f9f9', padding: '16px', borderRadius: '8px' }}>
                    <p style={{ color: '#666', fontWeight: '600', marginBottom: '8px' }}>Consultant Amount:</p>
                    <p style={{ fontSize: '16px' }}>{selectedFlag?.temporary_data.consultantAmount}</p>
                </div>
            </div>
        </div>
    );
};
